import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import {
  Grid,
  Icon,
  Transition,
} from 'semantic-ui-react';

moment.locale('en-gb');

class TimePicker extends Component {
  static propTypes = {
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.instanceOf(Date),
    ]),
    onChange: PropTypes.func,
    useBrowserTimezone: PropTypes.bool,
  }
  constructor(props) {
    super(props);
    const time = this.getTime(props.value, props.useBrowserTimezone);
    this.state = {
      time,
      hour: moment(time).format('hh'),
      minute: moment(time).format('mm'),
      isAM: moment(time).format('a') === 'am',
      visible: {
        hour: true,
        minute: true,
        isAM: true,
      },
    };
  }
  componentWillReceiveProps(nextProps) {
    const time = this.getTime(nextProps.value, nextProps.useBrowserTimezone);
    this.setState({
      time,
      hour: moment(time).format('hh'),
      minute: moment(time).format('mm'),
      isAM: moment(time).format('a') === 'am',
    });
  }
  getTime = (value, useBrowserTimezone = false) => (
    useBrowserTimezone ? moment(value).local() : moment(value)
  )
  setTime = (hour = 0, minute = 0) => {
    const m = moment(this.state.time);
    m.set({
      hour,
      minute,
      second: 0,
    });
    m.toISOString();
    m.format();
    return m;
  }
  format24Hour = (hour, isAM = this.state.isAM) => {
    let newHour = hour;
    if (isAM && hour === '12') {
      newHour = 0;
    } else if (!isAM && hour === '12') {
      newHour = 12;
    } else if (!isAM) {
      newHour = (parseInt(hour, 10) + 12);
    }
    return newHour;
  }
  handleHour = (e, decrement = false) => {
    e.persist();
    e.preventDefault();
    if (this.stepTimer) clearTimeout(this.stepTimer);
    const { visible, minute } = this.state;
    let { hour } = this.state;
    // increase/decrease value
    if (decrement) {
      hour = (parseInt(hour, 10) - 1).toString().padStart(2, '0');
    } else {
      hour = (parseInt(hour, 10) + 1).toString().padStart(2, '0');
    }
    // set 12 hour format
    if (hour === '13') {
      hour = '01';
    } else if (hour === '00') {
      hour = '12';
    }
    // transition
    visible.hour = !visible.hour;
    this.setState({
      hour,
      visible,
      time: this.setTime(this.format24Hour(hour), minute),
    }, () => {
      if (this.props.onChange) this.props.onChange(this.state.time.toDate());
    });
  }
  handleMinute = (e, decrement = false) => {
    e.persist();
    e.preventDefault();
    if (this.stepTimer) clearTimeout(this.stepTimer);
    const { visible, hour } = this.state;
    let { minute } = this.state;
    // increase/decrease value
    if (decrement) {
      minute = (parseInt(minute, 10) - 1).toString().padStart(2, '0');
    } else {
      minute = (parseInt(minute, 10) + 1).toString().padStart(2, '0');
    }
    // set number range
    if (minute === '60') {
      minute = '00';
    } else if (minute === '-1') {
      minute = '59';
    }
    // transition
    visible.minute = !visible.minute;
    this.setState({
      minute,
      visible,
      time: this.setTime(this.format24Hour(hour), minute),
    }, () => {
      if (this.props.onChange) this.props.onChange(this.state.time.toDate());
    });
  }
  handleAMPM = (e) => {
    e.preventDefault();
    if (this.stepTimer) clearTimeout(this.stepTimer);
    const { visible, hour, minute } = this.state;
    // transition
    visible.isAM = !visible.isAM;
    this.setState({
      isAM: !this.state.isAM,
      hour,
      visible,
      time: this.setTime(this.format24Hour(hour, !this.state.isAM), minute),
    }, () => {
      if (this.props.onChange) this.props.onChange(this.state.time.toDate());
    });
  }
  handleTicker = ({ e, decrement }, action, timeout = 150, count = 0) => {
    if (count < 500) {
      action(e, decrement);
      this.stepTimer = setTimeout(() => {
        this.handleTicker({ e, decrement }, action, timeout - 5, count + 1);
      }, timeout);
    }
  }
  handleClearTicker = () => {
    clearTimeout(this.stepTimer);
  }
  render() {
    const { hour, minute, isAM, visible } = this.state;
    return (
      <div>
        <Grid>
          <Grid.Row columns={3} className="clock_top controls">
            <Grid.Column>
              <Icon
                name="chevron up"
                fitted size="big"
                onTouchEnd={this.handleClearTicker}
                onTouchCancel={this.handleClearTicker}
                onMouseUp={this.handleClearTicker}
                onMouseOut={this.handleClearTicker}
                onMouseDown={e => this.handleTicker({ e }, this.handleHour)}
              />
            </Grid.Column>
            <Grid.Column>
              <Icon
                name="chevron up"
                fitted size="big"
                onTouchEnd={this.handleClearTicker}
                onTouchCancel={this.handleClearTicker}
                onMouseUp={this.handleClearTicker}
                onMouseOut={this.handleClearTicker}
                onMouseDown={e => this.handleTicker({ e }, this.handleMinute)}
              />
            </Grid.Column>
            <Grid.Column>
              <Icon
                name="chevron up"
                fitted size="big"
                onClick={this.handleAMPM}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={3} className="clock_numbers">
            <Grid.Column>
              <Transition animation={'pulse'} duration={150} visible={visible.hour}>
                <h2 className="clock_number">
                  {hour}
                </h2>
              </Transition>
            </Grid.Column>
            <Grid.Column>
              <Transition animation={'pulse'} duration={150} visible={visible.minute}>
                <h2 className="clock_number">
                  {minute}
                </h2>
              </Transition>
            </Grid.Column>
            <Grid.Column>
              <Transition animation={'pulse'} duration={150} visible={visible.isAM}>
                <h2 className="clock_number">
                  {isAM ? 'AM' : 'PM'}
                </h2>
              </Transition>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={3} className="clock_bottom controls">
            <Grid.Column>
              <Icon
                name="chevron down"
                fitted size="big"
                onTouchEnd={this.handleClearTicker}
                onTouchCancel={this.handleClearTicker}
                onMouseUp={this.handleClearTicker}
                onMouseOut={this.handleClearTicker}
                onMouseDown={e => this.handleTicker({ e, decrement: true }, this.handleHour)}
              />
            </Grid.Column>
            <Grid.Column>
              <Icon
                name="chevron down"
                fitted size="big"
                onTouchEnd={this.handleClearTicker}
                onTouchCancel={this.handleClearTicker}
                onMouseUp={this.handleClearTicker}
                onMouseOut={this.handleClearTicker}
                onMouseDown={e => this.handleTicker({ e, decrement: true }, this.handleMinute)}
              />
            </Grid.Column>
            <Grid.Column>
              <Icon
                name="chevron down"
                fitted size="big"
                onClick={this.handleAMPM}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default TimePicker;



// WEBPACK FOOTER //
// ./src/components/TimePicker.jsx